/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_ShoppingInputs */

const en_notify_shopping = /** @type {(inputs: Notify_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopping day`)
};

const de_notify_shopping = /** @type {(inputs: Notify_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkaufstag`)
};

/**
* | output |
* | --- |
* | "Shopping day" |
*
* @param {Notify_ShoppingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_shopping = /** @type {((inputs?: Notify_ShoppingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_ShoppingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_shopping(inputs)
	return en_notify_shopping(inputs)
});